import { IDiscountRepository } from '../domain/IDiscountRepository'

export class UpdateAssociations {
  constructor(public readonly discountRepository: IDiscountRepository) {}

  async execute(distributorId: number, discountId: string, discountableIds: string[]): Promise<void> {
    await this.discountRepository.upsertAssociations(distributorId, discountId, discountableIds)
  }
}
